let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aP9AA")).then(() => parcelRequire('6GPkr'));